import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { EmptyPage } from './pages/EmptyPage';
import { bookingItem, navItems } from './data/site';
export function App() {
  const otherPages = [...navItems.filter(item => item.to !== '/'), bookingItem];
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="2rlypgcwhuiig">
      <BrowserRouter data-id="element-1" data-mp="2rit3h6j5vwqy">
        <Routes data-id="element-2" data-mp="2mm2m8fvmev3y">
          <Route element={<Layout data-id="element-4" data-mp="2mmvk0rclqa9y" />} data-id="element-3" data-mp="2mmlt91jqfz37">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mjzn96chprn3" />} data-id="element-5" data-mp="2mnnh66lukg2c" />
            {otherPages.map(page => <Route key={page.to} path={page.to} element={<EmptyPage title={page.label} data-id="element-8" data-mp="2wk06ksad07ra" />} data-id="element-7" data-mp="31c9vq63nh3si" />)}
            <Route path="*" element={<Home data-id="element-10" data-mp="2wi5qbra193tj" />} data-id="element-9" data-mp="2wip54z4dzc3c" />
          </Route>
        </Routes>
      </BrowserRouter>
    </MotionConfig>;
}